const token = localStorage.getItem('authToken');

const PROD_DOMAIN = 'builderplaybook.net';
const isProduction = window.location.hostname.includes(PROD_DOMAIN) || window.location.hostname === '35.239.153.120';

export const Api = {

   // Switches automatically based on current hostname
   API_BASE_URL: isProduction 
       ? 'https://builderplaybook.net/api/' 
       : `http://${window.location.hostname}:3001/api/`,

   IMAGE_BASE_URL: isProduction
       ? 'https://builderplaybook.net/'
       : `http://${window.location.hostname}:3001/`,

    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    },
}

